export const ROLES = {
  COACH_MAINTENANCE: 'coach_maintenance_access',
  RMM_ACCESS: 'rmm_access',
  OFFER_ADMIN: 'offer_admin',
  PERFORMANCE_VIEW: 'performance_view',
  BOOK_MANAGEMENT: 'book_management',
  // Add or remove a member's credits from the Credits tab (abo-member-credits
  // ADR-001). DS enforces it again from the operator's FusionAuth registration.
  CREDITS_ADJUST: 'credits_adjust',
  // Cancel a book order (any live status) from its print-shop ticket. DS
  // enforces it again from the operator's FusionAuth registration;
  // unassigning it is the kill switch.
  PRINT_SHOP_CANCEL: 'print_shop_cancel',
  // Add, deactivate or activate an account manager and assign members to one
  // (abo-account-manager-assignment). DS enforces it again from the
  // operator's FusionAuth registration on every write.
  ACCOUNT_MANAGER_ADMIN: 'account_manager_admin',
} as const;
